module.exports = __webpack_public_path__ + "assets/img/driver-btn-f2b4970d.png";